import { render, staticRenderFns } from "./GlobalAiChat.vue?vue&type=template&id=b3c9e844&scoped=true"
import script from "./GlobalAiChat.vue?vue&type=script&lang=js"
export * from "./GlobalAiChat.vue?vue&type=script&lang=js"
import style0 from "./GlobalAiChat.vue?vue&type=style&index=0&id=b3c9e844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c9e844",
  null
  
)

export default component.exports